import React from 'react';
import { observer, inject } from 'mobx-react';
import style from './style.module.css';
// import Modal from 'react-modal';
import ReactPixel from 'react-facebook-pixel';

@inject(store => {
    const { myShopApiStore, ifaceMngr } = store;
    return { myShopApiStore, ifaceMngr };
})

@observer
class CreditIframe extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            interval: null
        }
    }

    componentDidMount = async() => {
        const { checkPreorderResp } = this.props.myShopApiStore;
        const { parentRef } = this.props;

        let resp = null;
        let isLoading = false;
        const interval = setInterval(async () => {
            if(!isLoading) {
                isLoading = true;
                resp = await checkPreorderResp();
                if(resp && resp.data.errorCode === '0'){
                    clearInterval(interval);
                    resp = null;
                    if(process.env.REACT_APP_FACEBOOK_PIXEL !== '') ReactPixel.track('AddPaymentInfo');
                    window.top.postMessage('close-iframe', parentRef);
                }
                isLoading = false;
            }
        }, 3000);

        this.setState({interval});
    }


    componentWillUnmount = () => {
        this.state.interval && clearInterval(this.state.interval)
    }

    render() {
        const { iframeRef, display } = this.props;
        const { sessionUrl } = this.props.myShopApiStore;
        
        return (
            <iframe
                ref={iframeRef}
                src={sessionUrl}
                width="100%"
                height="100%"
                style={{
                    borderRadius: "12px",
                    marginTop: "20px",
                    display: display
                }}>
            </iframe>
        )
    }
}

export default CreditIframe;